import { apiClient } from '../../../lib/api/client';
import type {
  OfferingCategoryDetail,
  OfferingCategoryFormValues,
  OfferingCategoryListItem,
  GetOfferingCategoriesParams,
  PagedResult,
} from '../types';

export async function getOfferingCategories(
  params: GetOfferingCategoriesParams = {}
): Promise<PagedResult<OfferingCategoryListItem>> {
  const {
    pageNumber = 1,
    pageSize = 10,
    search,
    activeOnly,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.set('pageNumber', String(pageNumber));
  searchParams.set('pageSize', String(pageSize));

  if (search !== undefined && search !== '') searchParams.set('search', search);
  if (activeOnly !== undefined) searchParams.set('activeOnly', String(activeOnly));

  const response = await apiClient.get<PagedResult<OfferingCategoryListItem>>(
    `/offerings/categories?${searchParams.toString()}`
  );
  return response.data;
}

export async function getOfferingCategoryById(id: string): Promise<OfferingCategoryDetail> {
  const response = await apiClient.get<OfferingCategoryDetail>(`/offerings/categories/${id}`);
  return response.data;
}

export async function createOfferingCategory(data: OfferingCategoryFormValues): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/offerings/categories', {
    title: data.title,
    description: data.description ?? null,
    isActive: data.isActive,
  });
  return response.data;
}

export async function deleteOfferingCategory(id: string): Promise<void> {
  await apiClient.delete(`/offerings/categories/${id}`);
}

export async function updateOfferingCategory(id: string, data: OfferingCategoryFormValues): Promise<void> {
  await apiClient.put(`/offerings/categories/${id}`, {
    title: data.title,
    description: data.description ?? null,
    isActive: data.isActive,
  });
}
